import { nextProjectUrl } from '../constants/urls';

const resolveAppUrl = (appId: string, appStatus?: string, absolute?: boolean, suffix?: string) => {
  const basePath = `/projects/${appId}`;

  const relativeUrl = suffix
    ? `${basePath}${suffix.startsWith('/') ? suffix : `/${suffix}`}`
    : basePath;

  return !(absolute ?? true) ? relativeUrl : nextProjectUrl.store(relativeUrl, true);
};

export { resolveAppUrl };
